import api from "./core";

const basePath = "api/core/Timeline";

export default {
  query(filter, extraHeaders = {}) {
    return api.post(`${basePath}`, filter, extraHeaders);
  }
};
